<template>
  <div class="operat-header"  v-show="!uiHiddenState.isHiddenNav">
    <div class="left-action" :style="leftActionStyle" :class="isLeftDrawVisible?'fade-left-visible':'fade-left-invisible'">
      <slot name="left-action"></slot>
    </div>
    <div class="right-action" :style="rightActionStyle" :class="isRightDrawVisible?'fade-rigth-visible':'fade-rigth-invisible'">
      <slot name="right-action"></slot>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'OperatHeader',
  props: {
    leftActionStyle: {
      type: Object,
      default: () => ({})
    },
    rightActionStyle: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters(['isRightDrawVisible', 'isLeftDrawVisible', 'uiHiddenState'])
  }
  // watch: {
  //   isRightDrawVisible (val) {
  //     if (val === false) {
  //       document.getElementById('navigationContainer').style.right = '10px'
  //     } else {
  //       document.getElementById('navigationContainer').style.right = '270px'
  //     }
  //   }
  // }
}
</script>

<style lang="scss" scoped>
.operat-header{
  display: flex;
  height: 40px;
  width: 100%;
  border-bottom: 1px solid #000000;
  background: #2C2D2E;
  position: absolute;
  top: 0px;
  // display: flex;
  align-items: center;
  font-size: 14px;
  color: #FFFFFF;
  // z-index: 1;
  .left-action{
    position: relative;
    text-align: left;
    left: 10px;
    width: 50%;
    &.fade-left-visible{
      left: 270px;
      transition:all 0.3s;
    }
    &.fade-left-invisible{
      left: 10px;
      transition:all 0.3s;
    }
  }

  .right-action{
    position: relative;
    text-align: right;
    right: 10px;
    width: 50%;
    &.fade-rigth-visible{
      right: 270px;
      transition:all 0.3s;
    }
    &.fade-rigth-invisible{
      right: 10px;
      transition:all 0.3s;
    }
  }
}
// .operat-header.shared .right-action {
//    right: 10px;
// }
</style>
